import * as actions from './actions'
import getters from './getters'
import mutations from './mutations'

const state = {
  error: false,
  user: {
    username: '',
    name: '',
    email: '',
    phone: '',
    skype: ''
  },
  notifications: []
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}
